module.exports = __webpack_public_path__ + "static/bt-ad0691b2e3616f993195d12eadb8f0fb.svg";